module.exports = __webpack_public_path__ + "static/img/xczjBanner@2x.52be8ddb.png";